// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"styles_sectionWrapper__sn0uJ","contentWrapper":"styles_contentWrapper__twuNB"};